<template>
  <div class="pa-20">
    <m-tiers
      :tiers="pointDeVente"
      :errors="errors"
      :messagesErrors="messagesErrors"
      :isEdit="isEditView"
      @msgErrorClose="msgErrorClose"
      @setAdresse="setPointDeVenteAdresse"
      ref="mtiers"
      minimumField/>

    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item">
          <b-button type="is-white" @click="$router.go(-1)">
            <p class="is-size-14px has-text-default">
              {{$t('general.btnAnnuler')}}
            </p>
          </b-button>
        </div>
        <div class="level-item">
          <b-button type="is-primary" @click="creerPointDeVente">
            <p class="is-size-14px has-text-weight-bold">
              {{ labeltrad.btnValider }}
            </p>
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { SET_POINT_DE_VENTE_ADRESSE, SET_POINT_DE_VENTE } from '@/store/modules/recommandations-mutation-type';
import * as config from '@/configuration/clientConf';
import { genererPointDeVente } from '@/services/client/genererTiers';
import { genererObjectErrorTiers, isInvalidClient } from '@/services/gestionPanneau/validationTiers';
import MTiers from '@/components/client/m_tiers.vue';

const Recommandations = createNamespacedHelpers('recommandations');

export default {
  components: {
    MTiers,
  },
  data () {
    return {
      config,
      messagesErrors: [],
      errors: genererObjectErrorTiers(),
      pointDeVente: genererPointDeVente(),
    };
  },
  watch: {
    pointDeVenteAdresse(adresseValue) {
      if (!adresseValue) return;
      this.pointDeVente.adressePostale = adresseValue;
    },
  },
  computed: {
    ...Recommandations.mapGetters({
      pointDeVenteAdresse: 'pointDeVenteAdresse',
      pointDeVenteRecommandation: 'pointDeVente',
    }),
    isEditView() {
      return !!this.pointDeVenteRecommandation;
    },
    labeltrad() {
      return {
        btnValider: this.isEditView
          ? this.$t('modifierPointDeVente.btnValider')
          : this.$t('creerPointDeVente.btnValider'),
      }
    },
  },
  methods: {
    ...Recommandations.mapMutations({
      setPointDeVente: SET_POINT_DE_VENTE,
      setPointDeVenteAdresse: SET_POINT_DE_VENTE_ADRESSE,
    }),
    msgErrorClose() {
      this.messagesErrors = [];
      this.errors = genererObjectErrorTiers();
    },
    creerPointDeVente() {
      if (isInvalidClient(this.pointDeVente, this.errors)) {
        this.messagesErrors.push(this.$t('general.msgErrorChampObligatoire'));
        return;
      }
      this.setPointDeVente(this.pointDeVente);
      this.$router.push({ name: this.isEditView ? 'liste-panneau' : 'creer-panneau' });
    },
  },
  mounted() {
    if (this.pointDeVenteRecommandation) {
      const { adressePostale } = this.pointDeVenteRecommandation;
      this.pointDeVente = cloneDeep(this.pointDeVenteRecommandation);
      this.setPointDeVenteAdresse({
        ...adressePostale,
        coordonnees: { lat: adressePostale.latitude, lng: adressePostale.longitude }
      });
    }
  },
};
</script>
